/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_SettingsInputs */



/**
* | output |
* | --- |
* | "Project Settings" |
*
* @param {Project_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_settings = /** @type {((inputs?: Project_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres du projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekteinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni del progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки проекта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Configuración del proyecto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("项目设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações do projeto")
	return /** @type {LocalizedString} */ ("Project Settings")
});